import * as S from './Header.style';

export { default as Header } from './Header';
export * from './Header.types';
export { S };
